import axios from 'axios'

const state = {
  sideBarCompliances: {},
  currentCompliance: {},
  currentComplianceFiles: {},
  currentVendorCompliance: {},
  selectedFile: {},
  dataForServer: {},
}

const getters = {
  getSelectedFile(state){
    return state.selectedFile;
  },

  getCurrentVendorCompliance(state){
    return state.currentVendorCompliance;
  }
}

const mutations = {
	/**
	 * Mutate any variable
	 * @param {string}
	 * @param {value}
	 */
	SET_VARIABLE(state, { key, value }) {
		eval('state.' + key + ' = value');
	},

	UPDATE_SELECTED_DATA(state, {key, value}){
		// append/update dataForServer
		state.dataForServer[key] = value;
  }
}

const actions = {
	setVariable({ commit }, { key, value }) {
		commit('SET_VARIABLE', { key: key, value: value });
	},

	updateSelectedData ({commit, state, dispatch}, {key, value}){
		commit('UPDATE_SELECTED_DATA', {key: key, value: value})
	},

  // update vendor compliance
  update({commit, dispatch, state, rootState}, id){
    var header = rootState.auth.header;
    var url = rootState.auth.l + 'v1/vendor-compliances/'+id;
    var data = state.dataForServer;

    axios.put(url, data, header).then(response => {
      var vendorCompliance = response.data.data;
      commit('SET_VARIABLE', {key: 'currentVendorCompliance', value: vendorCompliance});
      dispatch('getCompliancesForSidebar', vendorCompliance.vendor_id);
    }).catch( (error) => {
      console.log(error);
    });
  },

  getCompliance({commit, dispatch, state, rootState}, id){
    var header = rootState.auth.header;
    var url = rootState.auth.l + 'v1/compliances/'+id;

    axios.get(url, header).then(response => {
      var cCompliance = response.data.data;
      var cFiles = response.data.data.compliance_files.data;
      commit('SET_VARIABLE', {key: 'currentCompliance', value: cCompliance});
      commit('SET_VARIABLE', {key: 'currentComplianceFiles', value: cFiles});

      // get vendor compliance attached to this compliance
      dispatch('getVendorCompliance', cCompliance.id);
    }).catch( (error) => {
      console.log(error);
    });
  },

  /**
   * Retrieve vendor_compliances model
   currentVendorCompliance
   */
  getVendorCompliance({commit, dispatch, rootState}, compliance_id){
    var header = rootState.auth.header;
    var url = rootState.auth.l + 'v1/vendor-compliances?compliance_id='+compliance_id;

    axios.get(url, header).then(response => {
      //console.log("v compliance", response.data.data[0])
      var vendorCompliance = response.data.data[0];
      commit('SET_VARIABLE', {key: 'currentVendorCompliance', value: vendorCompliance});
      // vendor compliance details attached to this compliance
      
      if(typeof(vendorCompliance) !== 'undefined'){
        VueStore.dispatch('vendorComplianceDetails/setVariable', {key: 'currentVendorComplianceDetails', value: vendorCompliance.vendorComplianceDetails.data});
      }

    }).catch( (error) => {
      console.log(error);
    });
  },
  
  /**
   * Get vendor compliance details attached to this vendor_compliance
   */
  // getVendorComplianceDetails({commit, dispatch, rootState}, vendor_compliance_id){
  //   var header = rootState.auth.header;
  //   var url = rootState.auth.l + 'v1/vendor-compliance-details?vendor_compliance_id='+vendor_compliance_id;

  //   axios.get(url, header).then(response => {
  //     //console.log("v compliance", response.data.data[0])
  //     var vendorComplianceDetails = response.data.data;
  //     commit('SET_VARIABLE', {key: 'currentVendorComplianceDetails', value: vendorComplianceDetails});

  //   }).catch( (error) => {
  //     console.log(error);
  //   });

  // },

  /**
   * Get all compliances attached to vendor to generate sidebar
   */
  getCompliancesForSidebar({commit, dispatch, state, rootState}, vendor_id){
    var header = rootState.auth.header;
    var url = rootState.auth.l + 'v1/compliance-category-vendors?show=1&show_vendor=1&vendor_id='+vendor_id;

    axios.get(url, header).then(response => {
      var result = response.data;
      let newArray = [];
      for(const r in result){
        let nObject = {
          'category': r,
          'status': 'Incomplete',
          'items': result[r],
        }
        newArray.push(nObject);

      }
      //console.log("newObject", newArray);
      commit('SET_VARIABLE', {key: 'sideBarCompliances', value: newArray})
    }).catch( (error) => {
      console.log(error);
    });
  },


}

export default {
  namespaced: true,
	state,
	getters,
	mutations,
	actions
}